var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallHeartActive = function SvgSmallHeartActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#102262",
    stroke: "#102262",
    strokeLinecap: "round",
    d: "m7.303 13.1-.011-.011-.011-.01C5.322 11.352 3.743 9.94 2.648 8.615 1.56 7.295 1 6.115 1 4.86c0-2.039 1.574-3.61 3.625-3.61 1.126 0 2.263.532 2.994 1.393l.381.45.381-.45a4.012 4.012 0 0 1 2.994-1.393C13.425 1.25 15 2.821 15 4.86c0 1.103-.431 2.146-1.274 3.278-.848 1.14-2.085 2.333-3.645 3.732v.001L8.717 13.08l-.01.01-.01.01-.698.694-.697-.694Z"
  })));
};
export default SvgSmallHeartActive;